module.exports = __webpack_public_path__ + "img/detail-img.7de3754c.png";